import type { VariantProps } from "class-variance-authority"
import { cva } from "class-variance-authority"

export { default as Badge } from "./Badge.vue"

export const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-medium",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground border-transparent",
        secondary: "bg-secondary text-secondary-foreground border-transparent dark:border-muted-foreground/40",
        outline: "bg-transparent border-border text-foreground dark:border-muted-foreground/60",
        destructive: "bg-destructive text-destructive-foreground border-transparent",
        info: "bg-[var(--info-subtle)] text-[var(--info-foreground)] border-transparent",
        success: "bg-[var(--success-subtle)] text-[var(--success-foreground)] border-transparent",
        warning: "bg-[var(--warning-subtle)] text-[var(--warning-foreground)] border-transparent",
        danger: "bg-[var(--danger-subtle)] text-[var(--danger-foreground)] border-transparent",
      },
      size: {
        default: "text-xs px-2 py-0.5",
        sm: "text-[10px] px-1.5 py-0 gap-1",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
)

export type BadgeVariants = VariantProps<typeof badgeVariants>
